// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"328":"admin","461":"webfontloader","535":"login"}[chunkId] + "." + {"328":"5a64c77a","461":"f131a98f","535":"c949f012"}[chunkId] + ".js";
};